import { render, staticRenderFns } from "./ItineraryInfoPanel.vue?vue&type=template&id=01b04175"
import script from "./ItineraryInfoPanel.vue?vue&type=script&lang=js"
export * from "./ItineraryInfoPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports